// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"146":"8c75fe8b","319":"289d5dd9","353":"fa5a926e","667":"c0ae8967"}[chunkId] + ".chunk.css";
};